import type { RagWorkspace } from "../types.js";

function workspaceAdminRole(
  userId: string,
  workspace: Pick<RagWorkspace, "ownerId" | "members">,
): boolean {
  if (workspace.ownerId === userId) {
    return true;
  }

  const membership = workspace.members.find((member) => member.id === userId);
  return membership?.role === "admin" || membership?.role === "owner";
}

export function canManageWorkspaceSettings(
  userId: string | undefined,
  workspace: Pick<RagWorkspace, "ownerId" | "members">,
): boolean {
  if (!userId) {
    return false;
  }

  return workspaceAdminRole(userId, workspace);
}

export function canManageWorkspaceMembers(
  userId: string | undefined,
  workspace: Pick<RagWorkspace, "ownerId" | "isDefault" | "members">,
): boolean {
  if (!userId) {
    return false;
  }

  if (workspace.isDefault) {
    return workspace.ownerId === userId;
  }

  return workspaceAdminRole(userId, workspace);
}

export function canDeleteWorkspace(
  userId: string | undefined,
  workspace: Pick<RagWorkspace, "ownerId" | "isDefault" | "kind">,
  hasDeleteDefaultPermission = false,
): boolean {
  if (!userId) {
    return false;
  }

  // Org default workspaces are never deletable.
  if (workspace.kind === "ORGANIZATION") {
    if (workspace.isDefault) {
      return false;
    }
    // Non-default org: org-admin gate is applied via canDeleteKmWorkspace / kmWorkspace:delete.
    return true;
  }

  if (workspace.isDefault) {
    return hasDeleteDefaultPermission && workspace.ownerId === userId;
  }

  return workspace.ownerId === userId;
}
